import { makeStyles } from '@material-ui/core';

export const activityTimelineStyles = makeStyles(theme => ({
    panel: {
        position: 'sticky',
        top: theme.spacing(10),
    },
    title: {
        fontSize: theme.typography.h6.fontSize,
        fontWeight: 500,
        color: theme.typography.color,
        marginBottom: theme.spacing(2),
    },
    list: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
    entry: {
        display: 'flex',
        gap: theme.spacing(1.5),
        position: 'relative',
    },
    marker: {
        flexShrink: 0,
        marginTop: theme.spacing(0.5),
        color: theme.palette.primary.main,
        display: 'flex',
    },
    body: {
        minWidth: 0,
    },
    description: {
        fontSize: theme.typography.body2.fontSize,
        fontWeight: 600,
        color: theme.typography.color,
        wordBreak: 'break-word',
    },
    meta: {
        fontSize: theme.typography.caption.fontSize,
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(0.25),
    },
    ticketEntry: {
        cursor: 'pointer',
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(0.5),
        margin: theme.spacing(-0.5),
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    fallbackIcon: {
        fontSize: 10,
    },
    stateMessage: {
        fontSize: theme.typography.body2.fontSize,
        color: theme.palette.text.secondary,
    },
    errorMessage: {
        fontSize: theme.typography.body2.fontSize,
        color: theme.palette.error.main,
    },
}));
